import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log('=== LOGIN BAŞLADI ===');
    console.log('Backend URL:', BACKEND_URL);
    console.log('Email:', email);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        email,
        password
      });

      console.log('Login response:', response.data);

      // Save token
      localStorage.setItem('admin_token', response.data.access_token);
      
      toast.success('Giriş başarılı!');
      console.log('Navigating to dashboard...');
      
      // Navigate
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      console.error('Error response:', error.response?.data);
      toast.error(error.response?.data?.detail || 'Email veya şifre hatalı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <h1 className="admin-login-title">EDGE MARINE</h1>
          <h2 className="admin-login-subtitle">Admin Panel</h2>

          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="info@edgegemi.com"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Şifre</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="form-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="admin-login-button"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>

          <div style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#666' }}>
            Backend: {BACKEND_URL}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
